// ** DO NOT MODIFY **
// This file is auto-generated.
// To generate this file, type `npm run generate` in a terminal.

export type HljsLangID =
  "1c" |
  "abnf" |
  "accesslog" |
  "actionscript" |
  "ada" |
  "angelscript" |
  "apache" |
  "applescript" |
  "arcade" |
  "arduino" |
  "armasm" |
  "xml" |
  "asciidoc" |
  "aspectj" |
  "autohotkey" |
  "autoit" |
  "avrasm" |
  "awk" |
  "axapta" |
  "bash" |
  "basic" |
  "bnf" |
  "brainfuck" |
  "c" |
  "cal" |
  "capnproto" |
  "ceylon" |
  "clean" |
  "clojure" |
  "clojure-repl" |
  "cmake" |
  "coffeescript" |
  "coq" |
  "cos" |
  "cpp" |
  "crmsh" |
  "crystal" |
  "csharp" |
  "csp" |
  "css" |
  "d" |
  "markdown" |
  "dart" |
  "delphi" |
  "diff" |
  "django" |
  "dns" |
  "dockerfile" |
  "dos" |
  "dsconfig" |
  "dts" |
  "dust" |
  "ebnf" |
  "elixir" |
  "elm" |
  "ruby" |
  "erb" |
  "erlang-repl" |
  "erlang" |
  "excel" |
  "fix" |
  "flix" |
  "fortran" |
  "fsharp" |
  "gams" |
  "gauss" |
  "gcode" |
  "gherkin" |
  "glsl" |
  "gml" |
  "go" |
  "golo" |
  "gradle" |
  "graphql" |
  "groovy" |
  "haml" |
  "handlebars" |
  "haskell" |
  "haxe" |
  "hsp" |
  "http" |
  "hy" |
  "inform7" |
  "ini" |
  "irpf90" |
  "isbl" |
  "java" |
  "javascript" |
  "jboss-cli" |
  "json" |
  "julia" |
  "julia-repl" |
  "kotlin" |
  "lasso" |
  "latex" |
  "ldif" |
  "leaf" |
  "less" |
  "lisp" |
  "livecodeserver" |
  "livescript" |
  "llvm" |
  "lsl" |
  "lua" |
  "makefile" |
  "mathematica" |
  "matlab" |
  "maxima" |
  "mel" |
  "mercury" |
  "mipsasm" |
  "mizar" |
  "perl" |
  "mojolicious" |
  "monkey" |
  "moonscript" |
  "n1ql" |
  "nestedtext" |
  "nginx" |
  "nim" |
  "nix" |
  "node-repl" |
  "nsis" |
  "objectivec" |
  "ocaml" |
  "openscad" |
  "oxygene" |
  "parser3" |
  "pf" |
  "pgsql" |
  "php" |
  "php-template" |
  "plaintext" |
  "pony" |
  "powershell" |
  "processing" |
  "profile" |
  "prolog" |
  "properties" |
  "protobuf" |
  "puppet" |
  "purebasic" |
  "python" |
  "python-repl" |
  "q" |
  "qml" |
  "r" |
  "reasonml" |
  "rib" |
  "roboconf" |
  "routeros" |
  "rsl" |
  "ruleslanguage" |
  "rust" |
  "sas" |
  "scala" |
  "scheme" |
  "scilab" |
  "scss" |
  "shell" |
  "smali" |
  "smalltalk" |
  "sml" |
  "sqf" |
  "sql" |
  "stan" |
  "stata" |
  "step21" |
  "stylus" |
  "subunit" |
  "swift" |
  "taggerscript" |
  "yaml" |
  "tap" |
  "tcl" |
  "thrift" |
  "tp" |
  "twig" |
  "typescript" |
  "vala" |
  "vbnet" |
  "vbscript" |
  "vbscript-html" |
  "verilog" |
  "vhdl" |
  "vim" |
  "wasm" |
  "wren" |
  "x86asm" |
  "xl" |
  "xquery" |
  "zephir";

export const hljsLangAliasMap: Record<string, HljsLangID | HljsLangID[]> = {
  "1c": "1c",
  "abnf": "abnf",
  "accesslog": "accesslog",
  "actionscript": "actionscript",
  "as": "actionscript",
  "ada": "ada",
  "angelscript": "angelscript",
  "asc": "angelscript",
  "apache": "apache",
  "apacheconf": "apache",
  "applescript": "applescript",
  "osascript": "applescript",
  "arcade": "arcade",
  "arduino": "arduino",
  "ino": "arduino",
  "armasm": "armasm",
  "arm": "armasm",
  "asciidoc": "asciidoc",
  "adoc": "asciidoc",
  "aspectj": "aspectj",
  "autohotkey": "autohotkey",
  "ahk": "autohotkey",
  "autoit": "autoit",
  "avrasm": "avrasm",
  "awk": "awk",
  "axapta": "axapta",
  "x++": "axapta",
  "bash": "bash",
  "sh": "bash",
  "basic": "basic",
  "bnf": "bnf",
  "brainfuck": "brainfuck",
  "bf": "brainfuck",
  "c": "c",
  "h": "c",
  "cal": "cal",
  "capnproto": "capnproto",
  "capnp": "capnproto",
  "ceylon": "ceylon",
  "clean": "clean",
  "dcl": "clean",
  "icl": "clean",
  "clojure": "clojure",
  "clj": "clojure",
  "edn": "clojure",
  "clojure-repl": "clojure-repl",
  "cmake": "cmake",
  "cmake.in": "cmake",
  "coffeescript": "coffeescript",
  "coffee": "coffeescript",
  "cson": "coffeescript",
  "iced": "coffeescript",
  "coq": "coq",
  "cos": "cos",
  "cls": "cos",
  "cpp": "cpp",
  "c++": "cpp",
  "cc": "cpp",
  "cxx": "cpp",
  "h++": "cpp",
  "hh": "cpp",
  "hpp": "cpp",
  "hxx": "cpp",
  "crmsh": "crmsh",
  "crm": "crmsh",
  "pcmk": "crmsh",
  "crystal": "crystal",
  "cr": "crystal",
  "csharp": "csharp",
  "c#": "csharp",
  "cs": "csharp",
  "csp": "csp",
  "css": "css",
  "d": "d",
  "dart": "dart",
  "delphi": "delphi",
  "dfm": "delphi",
  "dpr": "delphi",
  "pas": "delphi",
  "pascal": "delphi",
  "diff": "diff",
  "patch": "diff",
  "django": "django",
  "jinja": "django",
  "dns": "dns",
  "bind": "dns",
  "zone": "dns",
  "dockerfile": "dockerfile",
  "docker": "dockerfile",
  "dos": "dos",
  "bat": "dos",
  "cmd": "dos",
  "dsconfig": "dsconfig",
  "dts": "dts",
  "dust": "dust",
  "dst": "dust",
  "ebnf": "ebnf",
  "elixir": "elixir",
  "ex": "elixir",
  "exs": "elixir",
  "elm": "elm",
  "erb": "erb",
  "erlang": "erlang",
  "erl": "erlang",
  "erlang-repl": "erlang-repl",
  "excel": "excel",
  "xls": "excel",
  "xlsx": "excel",
  "fix": "fix",
  "flix": "flix",
  "fortran": "fortran",
  "f90": "fortran",
  "f95": "fortran",
  "fsharp": "fsharp",
  "f#": "fsharp",
  "fs": "fsharp",
  "gams": "gams",
  "gms": "gams",
  "gauss": "gauss",
  "gss": "gauss",
  "gcode": "gcode",
  "nc": "gcode",
  "gherkin": "gherkin",
  "feature": "gherkin",
  "glsl": "glsl",
  "gml": "gml",
  "go": "go",
  "golang": "go",
  "golo": "golo",
  "gradle": "gradle",
  "graphql": "graphql",
  "gql": "graphql",
  "groovy": "groovy",
  "haml": "haml",
  "handlebars": "handlebars",
  "hbs": "handlebars",
  "html.handlebars": "handlebars",
  "html.hbs": "handlebars",
  "htmlbars": "handlebars",
  "haskell": "haskell",
  "hs": "haskell",
  "haxe": "haxe",
  "hx": "haxe",
  "hsp": "hsp",
  "http": "http",
  "https": "http",
  "hy": "hy",
  "hylang": "hy",
  "inform7": "inform7",
  "i7": "inform7",
  "ini": "ini",
  "toml": "ini",
  "irpf90": "irpf90",
  "isbl": "isbl",
  "java": "java",
  "jsp": "java",
  "javascript": "javascript",
  "cjs": "javascript",
  "js": "javascript",
  "jsx": "javascript",
  "mjs": "javascript",
  "jboss-cli": "jboss-cli",
  "wildfly-cli": "jboss-cli",
  "json": "json",
  "julia": "julia",
  "julia-repl": "julia-repl",
  "jldoctest": "julia-repl",
  "kotlin": "kotlin",
  "kt": "kotlin",
  "kts": "kotlin",
  "lasso": "lasso",
  "lassoscript": "lasso",
  "ls": [
    "lasso",
    "livescript"
  ],
  "latex": "latex",
  "tex": "latex",
  "ldif": "ldif",
  "leaf": "leaf",
  "less": "less",
  "lisp": "lisp",
  "livecodeserver": "livecodeserver",
  "livescript": "livescript",
  "llvm": "llvm",
  "lsl": "lsl",
  "lua": "lua",
  "makefile": "makefile",
  "mak": "makefile",
  "make": "makefile",
  "mk": "makefile",
  "markdown": "markdown",
  "md": "markdown",
  "mkd": "markdown",
  "mkdown": "markdown",
  "mathematica": "mathematica",
  "mma": "mathematica",
  "wl": "mathematica",
  "matlab": "matlab",
  "maxima": "maxima",
  "mel": "mel",
  "mercury": "mercury",
  "m": "mercury",
  "moo": "mercury",
  "mipsasm": "mipsasm",
  "mips": "mipsasm",
  "mizar": "mizar",
  "mojolicious": "mojolicious",
  "monkey": "monkey",
  "moonscript": "moonscript",
  "moon": "moonscript",
  "n1ql": "n1ql",
  "nestedtext": "nestedtext",
  "nt": "nestedtext",
  "nginx": "nginx",
  "nginxconf": "nginx",
  "nim": "nim",
  "nix": "nix",
  "nixos": "nix",
  "node-repl": "node-repl",
  "nsis": "nsis",
  "objectivec": "objectivec",
  "mm": "objectivec",
  "obj-c": "objectivec",
  "obj-c++": "objectivec",
  "objc": "objectivec",
  "objective-c++": "objectivec",
  "ocaml": "ocaml",
  "ml": [
    "ocaml",
    "sml"
  ],
  "openscad": "openscad",
  "scad": "openscad",
  "oxygene": "oxygene",
  "parser3": "parser3",
  "perl": "perl",
  "pl": "perl",
  "pm": "perl",
  "pf": "pf",
  "pf.conf": "pf",
  "pgsql": "pgsql",
  "postgres": "pgsql",
  "postgresql": "pgsql",
  "php": "php",
  "php-template": "php-template",
  "plaintext": "plaintext",
  "text": "plaintext",
  "txt": "plaintext",
  "pony": "pony",
  "powershell": "powershell",
  "ps": "powershell",
  "ps1": "powershell",
  "pwsh": "powershell",
  "processing": "processing",
  "pde": "processing",
  "profile": "profile",
  "prolog": "prolog",
  "properties": "properties",
  "protobuf": "protobuf",
  "proto": "protobuf",
  "puppet": "puppet",
  "pp": "puppet",
  "purebasic": "purebasic",
  "pb": "purebasic",
  "pbi": "purebasic",
  "python": "python",
  "gyp": "python",
  "ipython": "python",
  "py": "python",
  "python-repl": "python-repl",
  "pycon": "python-repl",
  "q": "q",
  "k": "q",
  "kdb": "q",
  "qml": "qml",
  "qt": "qml",
  "r": "r",
  "reasonml": "reasonml",
  "re": "reasonml",
  "rib": "rib",
  "roboconf": "roboconf",
  "graph": "roboconf",
  "instances": "roboconf",
  "routeros": "routeros",
  "mikrotik": "routeros",
  "rsl": "rsl",
  "ruby": "ruby",
  "gemspec": "ruby",
  "irb": "ruby",
  "podspec": "ruby",
  "rb": "ruby",
  "thor": "ruby",
  "ruleslanguage": "ruleslanguage",
  "rust": "rust",
  "rs": "rust",
  "sas": "sas",
  "scala": "scala",
  "scheme": "scheme",
  "scm": "scheme",
  "scilab": "scilab",
  "sci": "scilab",
  "scss": "scss",
  "shell": "shell",
  "console": "shell",
  "shellsession": "shell",
  "smali": "smali",
  "smalltalk": "smalltalk",
  "st": "smalltalk",
  "sml": "sml",
  "sqf": "sqf",
  "sql": "sql",
  "stan": "stan",
  "stanfuncs": "stan",
  "stata": "stata",
  "ado": "stata",
  "do": "stata",
  "step21": "step21",
  "p21": "step21",
  "step": "step21",
  "stp": "step21",
  "stylus": "stylus",
  "styl": "stylus",
  "subunit": "subunit",
  "swift": "swift",
  "taggerscript": "taggerscript",
  "tap": "tap",
  "tcl": "tcl",
  "tk": "tcl",
  "thrift": "thrift",
  "tp": "tp",
  "twig": "twig",
  "craftcms": "twig",
  "typescript": "typescript",
  "cts": "typescript",
  "mts": "typescript",
  "ts": "typescript",
  "tsx": "typescript",
  "vala": "vala",
  "vbnet": "vbnet",
  "vb": "vbnet",
  "vbscript": "vbscript",
  "vbs": "vbscript",
  "vbscript-html": "vbscript-html",
  "verilog": "verilog",
  "sv": "verilog",
  "svh": "verilog",
  "v": "verilog",
  "vhdl": "vhdl",
  "vim": "vim",
  "wasm": "wasm",
  "wren": "wren",
  "x86asm": "x86asm",
  "xl": "xl",
  "tao": "xl",
  "xml": "xml",
  "atom": "xml",
  "html": "xml",
  "plist": "xml",
  "rss": "xml",
  "svg": "xml",
  "wsf": "xml",
  "xhtml": "xml",
  "xjb": "xml",
  "xsd": "xml",
  "xsl": "xml",
  "xquery": "xquery",
  "xpath": "xquery",
  "xq": "xquery",
  "yaml": "yaml",
  "yml": "yaml",
  "zephir": "zephir",
  "zep": "zephir"
};

export const hljsSubLangMap: Record<string, HljsLangID[]> = {
  "asciidoc": [
    "xml"
  ],
  "clojure-repl": [
    "clojure"
  ],
  "coffeescript": [
    "javascript"
  ],
  "cos": [
    "sql",
    "javascript",
    "xml"
  ],
  "dart": [
    "markdown"
  ],
  "django": [
    "xml"
  ],
  "dockerfile": [
    "bash"
  ],
  "dust": [
    "xml"
  ],
  "erb": [
    "xml",
    "ruby"
  ],
  "haml": [
    "ruby"
  ],
  "handlebars": [
    "xml"
  ],
  "javascript": [
    "xml",
    "css",
    "graphql"
  ],
  "julia-repl": [
    "julia"
  ],
  "livescript": [
    "javascript"
  ],
  "markdown": [
    "xml"
  ],
  "mojolicious": [
    "xml",
    "perl"
  ],
  "node-repl": [
    "javascript"
  ],
  "parser3": [
    "xml"
  ],
  "perl": [
    "mojolicious"
  ],
  "pgsql": [
    "perl",
    "python",
    "tcl",
    "r",
    "lua",
    "java",
    "php",
    "ruby",
    "bash",
    "scheme",
    "xml",
    "json"
  ],
  "php-template": [
    "xml",
    "php"
  ],
  "python-repl": [
    "python"
  ],
  "qml": [
    "xml"
  ],
  "shell": [
    "bash"
  ],
  "tap": [
    "yaml"
  ],
  "twig": [
    "xml"
  ],
  "typescript": [
    "xml",
    "css",
    "graphql"
  ],
  "vbscript-html": [
    "xml",
    "vbscript"
  ],
  "xml": [
    "css",
    "javascript",
    "handlebars"
  ],
  "xquery": [
    "xml"
  ],
  "yaml": [
    "ruby"
  ]
};
